/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Minifier_Deep_TitleInputs */

const en_minifier_deep_title = /** @type {(inputs: Minifier_Deep_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How much minification really saves once gzip is involved`)
};

const ko_minifier_deep_title = /** @type {(inputs: Minifier_Deep_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`gzip을 고려하면 압축이 실제로 얼마나 절감하는가`)
};

const ja_minifier_deep_title = /** @type {(inputs: Minifier_Deep_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`gzip を考えると圧縮は実際どれだけ効くか`)
};

/**
* | output |
* | --- |
* | "How much minification really saves once gzip is involved" |
*
* @param {Minifier_Deep_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const minifier_deep_title = /** @type {((inputs?: Minifier_Deep_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Minifier_Deep_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_minifier_deep_title(inputs)
	if (locale === "ko") return ko_minifier_deep_title(inputs)
	return ja_minifier_deep_title(inputs)
});